import { Box } from "@mui/material";
import { useState, useEffect } from "react";
import StepperBiodiversidadComponent from "../components/formsBioVegetal/StepperBiodiversidad";
import FormBioStepOneComponent from "../components/formsBioVegetal/FormBioStepOne";
import FormBioStepTwoComponent from "../components/formsBioVegetal/FormBioStepTwo";
import FormBioStepThreeComponent from "../components/formsBioVegetal/FormBioStepThree";
import FormBioStepFourComponent from "../components/formsBioVegetal/FormBioStepFour";


const BioVegetalPage = () => {

    const [ position, setPosition ] = useState(0);
    const [ stateForm, setStateForm ] = useState({
        finca: {id: ""},
        fecha: "",
        tipoAnalisis: "",
        comunidad: {id: ""},
        tipoVegetacion: {
            cultivoslenosos: false,
            cubiertavegetal: false,
            bosquesierramatorral: false,
            cultivoanualherbaceo: false,
            lindero: false,
            bosqueisla: false
        },
        especies: {},
        muestreos: {},
        metroslinealesLindero: "",
        diccionario: []
    });

    useEffect(() => {
        document.title = "Nueva biodiversidad vegetal";
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
    };

    return(
        <div className="tic4bio-home">
            <StepperBiodiversidadComponent position={position} setPosition={setPosition}/>  
            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                <FormBioStepOneComponent position={position} setPosition={setPosition} stateForm={stateForm} setStateForm={setStateForm}/>
                {(position === 1 || (stateForm.comunidad.id !== "")) &&
                    <>
                        <FormBioStepTwoComponent position={position} setPosition={setPosition} stateForm={stateForm} setStateForm={setStateForm}/>
                    </>
                }
                {(position === 2) &&
                    <>
                        <FormBioStepThreeComponent position={position} setPosition={setPosition} stateForm={stateForm} setStateForm={setStateForm}/>
                    </>
                }
                {(position === 3) &&
                    <>
                        <FormBioStepFourComponent position={position} setPosition={setPosition} stateForm={stateForm} setStateForm={setStateForm}/>
                    </>
                }
            </Box>
        </div>
    );
}
export default BioVegetalPage;